module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container blog-display"
  }, [_c('div', {
    staticClass: "inner-blog"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "blog-list news_block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "blog-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/images/earth.jpg"),
      "alt": "earth"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "news_in blog-detail"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])]), _vm._v(" "), _c('small', [_vm._v("DECEMBER 9, 2016"), _c('em', [_vm._v("Chloe Parkin")])]), _vm._v(" "), _c('h6', {
    staticClass: "para"
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "blog-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/images/earth.jpg"),
      "alt": "earth"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "news_in blog-detail"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])]), _vm._v(" "), _c('small', [_vm._v("DECEMBER 9, 2016"), _c('em', [_vm._v("Chloe Parkin")])]), _vm._v(" "), _c('h6', {
    staticClass: "para"
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "blog-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/images/earth.jpg"),
      "alt": "earth"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "news_in blog-detail"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])]), _vm._v(" "), _c('small', [_vm._v("DECEMBER 9, 2016"), _c('em', [_vm._v("Chloe Parkin")])]), _vm._v(" "), _c('h6', {
    staticClass: "para"
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticClass: "blog-image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/images/earth.jpg"),
      "alt": "earth"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "news_in blog-detail"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])]), _vm._v(" "), _c('small', [_vm._v("DECEMBER 9, 2016"), _c('em', [_vm._v("Chloe Parkin")])]), _vm._v(" "), _c('h6', {
    staticClass: "para"
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('nav', {
    attrs: {
      "aria-label": "Page navigation nav-pg clearfix"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "posts clearfix"
  }, [_c('div', {
    staticClass: "news_block latest"
  }, [_c('h4', [_vm._v("POPULAR POSTS")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/tower.jpg"),
      "alt": "tower",
      "width": "80",
      "height": "80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "news_in col-xs-8"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Paris confronts worst wintertime pollution in 10 years with bold transport limitations")])]), _vm._v(" "), _c('small', [_vm._v("DECEMBER 9, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('li', [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/map.jpg"),
      "alt": "map",
      "width": "80",
      "height": "80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "news_in col-xs-8"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("2 billion children breathing unsafe outdoor air worldwide")])]), _vm._v(" "), _c('small', [_vm._v("NOVEMBER 8, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('li', [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/east.jpg"),
      "alt": "east",
      "width": "80",
      "height": "80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "news_in col-xs-8"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("New WHO model shows 92% of world’s population breathing dangerous air")])]), _vm._v(" "), _c('small', [_vm._v("OCTOBER 8, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "contribute col-xs-12"
  }, [_c('p', [_c('br'), _c('span', [_vm._v("Air pollution is everywhere.")]), _c('br'), _vm._v(" It’s the cause behind 1 in every 8 deaths worldwide. "), _c('br'), _vm._v(" Let’s change this!")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ea44e96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 311
// module chunks = 1